import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "@emotion/react";
import S from "./ChannelItem.styled";
import Avatar from "../Avatar/Avatar";
import MessageDate from "../Message/MessageDate";
import { useChannel, useExternalUsers, useTranslation } from "../../hooks";
export default function ChannelItem({ isSelected, onClick, }) {
    var _a, _b, _c, _d;
    const channel = useChannel();
    const theme = useTheme();
    const strings = useTranslation();
    const users = useExternalUsers();
    const [membersCount, setMembersCount] = useState(0);
    const [lastMessage, setLastMessage] = useState(channel.lastMessage);
    const [unreadCount, setUnreadCount] = useState(channel.unreadMessagesCount);
    const lastMessageSenderWithSender = useMemo(() => {
        const sender = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender.id) === channel.currentUserId
            ? strings.currentSender
            : lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender.name.split(" ")[0];
        return `${sender}: ${lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.text}`;
    }, [lastMessage, channel.currentUserId, strings.currentSender]);
    const [channelName, channelImage] = useMemo(() => {
        var _a, _b;
        const internalChannelName = (_a = (channel.name || channel.data.name)) !== null && _a !== void 0 ? _a : "Without name";
        const person = channel.members.find((member) => member.id !== channel.currentUserId);
        if (person === null || person === void 0 ? void 0 : person.name) {
            const name = channel.channelType === "restricted"
                ? internalChannelName
                : person.name;
            return [name, person.image];
        }
        const externalId = (_b = channel.data.members) === null || _b === void 0 ? void 0 : _b.find((id) => id !== channel.currentUserId);
        const externalPerson = externalId ? users.get(externalId) : undefined;
        if (externalPerson) {
            const name = channel.channelType === "restricted"
                ? internalChannelName
                : externalPerson.name;
            return [name, externalPerson.image];
        }
        return [channel.name, undefined];
    }, [users, channel]);
    useEffect(() => {
        var _a, _b;
        setMembersCount((_b = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
        const unsubscribeFunctions = [
            channel.on("newMessage", (event) => {
                setLastMessage(event.message);
            }),
            channel.on("updateUnreadCount", (event) => {
                setUnreadCount(event.count);
            }),
            channel.on("removeMembers", () => {
                var _a, _b;
                setMembersCount((_b = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            }),
            channel.on("addMembers", () => {
                var _a, _b;
                setMembersCount((_b = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            }),
        ];
        return () => {
            unsubscribeFunctions.forEach((f) => f.unsubscribe());
        };
    }, [channel]);
    return (React.createElement(S.Button, { onClick: () => {
            channel.markLastMessageAsRead();
            onClick();
        }, type: "button" },
        React.createElement(S.Item, { isSelected: isSelected, theme: theme },
            React.createElement(Avatar, { src: channelImage, alt: channelName }),
            channel.channelType === "restricted" && (React.createElement(S.NumberOfMembersIcon, null, (_b = (_a = channel.data.members) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0)),
            React.createElement(S.ItemContainer, null,
                React.createElement(S.ItemHeader, null,
                    React.createElement(S.ItemHeaderText, null, channelName),
                    !!((_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.date) && (React.createElement(MessageDate, { date: new Date((_d = channel.lastMessage) === null || _d === void 0 ? void 0 : _d.date) }))),
                lastMessage ? (React.createElement(S.Text, { "data-testid": "lastMessage" }, lastMessageSenderWithSender)) : (React.createElement(S.Text, null,
                    React.createElement("i", null, "Write the first message")))),
            unreadCount > 0 ? (React.createElement(S.UnreadMessageIcon, null, unreadCount > 9 ? "9+" : unreadCount)) : null)));
}
//# sourceMappingURL=ChannelItem.js.map